import React from "react";
import { Modal } from "react-bootstrap";

type OwnProps = {
  showModal: boolean;
  onConfirm: () => any;
  onHide: () => any;
};

type Props = OwnProps;

class DiscardConfirmModal extends React.Component<Props> {
  render() {
    const { showModal } = this.props;
    return (
      <Modal
        show={showModal}
        onHide={this.props.onHide}
        animation={false}
        centered
        backdropClassName="customDarkModalBackdrop in"
      >
        <Modal.Header
          closeButton
          className={"purpleModalHeader font-weight-bold"}
        >
          <Modal.Title>Discard Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p className="font-weight-bold">Are you sure you want to discard this group?</p>
            <p>The group will be removed from your list of Recommendations.</p>
          </div>
          <hr />
          <div className="d-flex justify-content-between">
            <button className="whiteBtnSm mr-2" onClick={this.props.onHide}>
              Cancel
            </button>
            <button className="blueBtnSm" onClick={this.props.onConfirm}>
              Yes, Discard
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default DiscardConfirmModal;
